// 工单配置
<template>
  <el-card class="card-main">
    <el-form ref="searchInfo" :model="searchInfo" class="global-form" :inline="true">
      <el-form-item>
        <el-select v-model="searchInfo.projectId" placeholder="请选择所属项目" filterable clearable @change="getTypeList">
          <el-option v-for="item in projectList" :key="item.projectId" :label="item.projectName"
            :value="item.projectId"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-select v-model="searchInfo.orderType" placeholder="请选择工单类型" filterable clearable
          :disabled="!searchInfo.projectId">
          <el-option v-for="item in typeList" :key="item.orderType" :label="item.orderTypeName"
            :value="item.orderType"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="orderTitle">
        <el-input v-model="searchInfo.orderTitle" clearable placeholder="请输入工单编号" />
      </el-form-item>
      <el-form-item prop="orderStatus">
        <el-select v-model="searchInfo.orderStatus" placeholder="请选择工单状态" clearable>
          <el-option v-for="(item, index) in statusList" :key="index" :label="item" :value="index"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="orderUserName">
        <el-input v-model="searchInfo.orderUserName" clearable placeholder="请输入当前处理人" />
      </el-form-item>
      <el-form-item>
        <el-date-picker v-model="dateArr" value-format="yyyy-MM-dd" start-placeholder="开始日期" end-placeholder="结束日期"
          type="daterange" placeholder="请选择日期" @change="dateChange"></el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSearch" class="medium">查询</el-button>
      </el-form-item>
    </el-form>
    <el-table class="global-table" stripe v-loading="tableData.loading" :data="tableData.data">
      <el-table-column :label="item.label" :prop="item.prop" :min-width="item.minWidth || ''"
        :show-overflow-tooltip="item.showOverflowTooltip || false" v-for="(item, index) in tableData.tr" :key="index">
        <template v-slot="{ row }">
          <template v-if="item.prop === 'orderStatus'">
            <span>{{ getStatusName(row.orderStatus) }}</span>
          </template>
          <span v-else>{{ row[item.prop] }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="180px" fixed="right">
        <template v-slot="{ row }">
          <el-button type="text" @click="onUrge(row.orderId)"
            v-show="$ButtonShow('urge') && row.orderStatus !== '3' && row.orderStatus !== '2'">催办</el-button>
          <el-button type="text" @click="onDetailShow(row, '4')">查看</el-button>
          <el-button type="text" @click="onDetailShow(row)"
            v-show="$ButtonShow('YOD_ADD_06') && row.orderStatus !== '3' && row.orderStatus !== '2'">处理</el-button>
          <el-button type="text" @click="onDetailShow(row, '2')"
            v-show="$ButtonShow('YOD_ADD_05') && row.orderStatus !== '3' && row.orderStatus !== '2'">转办</el-button>
          <el-button type="text" @click="onDetailShow(row, '3')"
            v-show="$ButtonShow('YOD_ADD_07') && row.orderStatus !== '3' && row.orderStatus !== '2'">关闭</el-button>
        </template>
      </el-table-column>
    </el-table>
    <GlobalPagination @current-change="getData" @size-change="getData" :current-page.sync="page" :page-size.sync="size"
      :total="total">
    </GlobalPagination>

    <OrderDetailDialog v-if="detailShow" :detailShow="detailShow" :isMyOrder="false" :orderId='orderId'
      :handleType='handleType' @closeDialog="closeDialog"></OrderDetailDialog>
  </el-card>
</template>

<script>
import OrderDetailDialog from './OrderDetailDialog.vue'
import keepAlive from '@/mixins/keepAlive.js'

export default {
  name: 'OrderManage',
  mixins: [keepAlive],
  components: {
    OrderDetailDialog
  },
  data () {
    return {
      searchInfo: {
        projectId: '',
        orderType: '',
        orderTitle: '',
        orderStatus: '',
        orderUserName: '',
        startTime: '',
        endTime: ''
      },

      dateArr: [],
      statusList: ['待反馈', '待审核', '已完成', '已关闭'],
      tableData: {
        loading: false,
        tr: [
          {
            label: '工单编号',
            prop: 'orderId',
            minWidth: '100',
            showOverflowTooltip: true
          },
          {
            label: '归属项目',
            prop: 'projectName',
            minWidth: '100',
            showOverflowTooltip: true
          },
          {
            label: '工单类型',
            prop: 'orderTypeName',
            minWidth: '100',
            showOverflowTooltip: true
          },
          {
            label: '工单内容',
            prop: 'orderContent',
            minWidth: '100',
            showOverflowTooltip: true
          },
          {
            label: '工单截止日期',
            prop: 'orderDate',
            minWidth: '100',
            showOverflowTooltip: true
          },
          {
            label: '状态',
            prop: 'orderStatus',
            minWidth: '100',
            showOverflowTooltip: true
          },
          {
            label: '当前处理人',
            prop: 'orderUserName',
            minWidth: '100',
            showOverflowTooltip: true
          },
          {
            label: '创建时间',
            prop: 'ctime',
            minWidth: '100',
            showOverflowTooltip: true
          }
        ],
        data: []
      },
      total: 0,
      page: 1,
      size: 10,
      typeList: [],
      detailShow: false,
      handleType: '0', // 处理类型 4：查看 0：反馈 1：审核 2：转办 3：关闭
      orderId: ''
    }
  },
  computed: {
    projectList () {
      return this.$store.state.projectList
    }

  },

  created () {
    this.getData()
  },
  methods: {
    getTypeList () {
      this.searchInfo.orderType = ''
      this.$axios.get(this.$apis.workOrder.selectWorkOrderTypeByList, {
        projectId: this.searchInfo.projectId,
        orderTypeStatus: '1'
      }).then((res) => {
        this.typeList = res.list || []
      })
    },

    getData () {
      this.tableData.loading = true
      this.$axios.get(this.$apis.workOrder.selectWorkOrderByPage, {
        ...this.searchInfo,
        page: this.page,
        size: this.size
      }).then((res) => {
        this.total = res.total || 0
        this.tableData.data = res.list || []
      }).finally(() => {
        this.tableData.loading = false
      })
    },

    onSearch () {
      this.page = 1
      this.getData()
    },

    getStatusName (orderStatus) {
      return this.statusList[Number(orderStatus)]
    },

    dateChange (date) {
      if (date) {
        this.searchInfo.startTime = date[0]
        this.searchInfo.endTime = date[1]
      } else {
        this.searchInfo.startTime = ''
        this.searchInfo.endTime = ''
      }
    },

    onUrge (orderId) {
      this.$axios.post(this.$apis.workOrder.pressingWorkOrder, { orderId }).then((res) => {
        this.$message.success('催办成功')
      })
    },

    onDetailShow (row, type) {
      if (type) {
        this.handleType = type
      } else {
        this.handleType = row.orderStatus || ''
      }
      this.orderId = row.orderId || ''
      this.detailShow = true
    },

    closeDialog () {
      this.detailShow = false
      this.getData()
    }
  }

}
</script>

<style scoped lang="scss"></style>
